module.exports = __webpack_public_path__ + "media/content-creator/mobile-fmcg-1-f3de8dd5.png";